import { Button } from "@volca/ui/components/ui/button";
import { cn } from "@volca/ui/lib/utils";
import {
  REFERRAL_COLUMN_TO_STATUS,
  REFERRAL_COLUMN,
} from "@/referrals/constants";
import type { IReferral, ReferralColumn } from "@/referrals/referral";

interface ReferralActionButtonProps {
  referral: IReferral;
  onNextColumn: (column: ReferralColumn, referral: IReferral) => void;
  onPayout: () => void;
  className?: string;
  size?: "sm" | "default" | "lg";
}

export const ReferralActionButton = ({
  referral,
  onNextColumn,
  onPayout,
  className,
  size = "sm",
}: ReferralActionButtonProps) => {
  switch (referral?.status) {
    case REFERRAL_COLUMN_TO_STATUS.new:
      return (
        <Button
          className={cn("w-full", className)}
          size={size}
          type="button"
          onClick={() => onNextColumn(REFERRAL_COLUMN.inProgress, referral)}
        >
          Accept
        </Button>
      );
    case REFERRAL_COLUMN_TO_STATUS.inProgress:
      return (
        <Button
          className={cn("w-full", className)}
          size={size}
          type="button"
          onClick={() => onNextColumn(REFERRAL_COLUMN.scheduled, referral)}
        >
          Move to scheduled
        </Button>
      );
    case REFERRAL_COLUMN_TO_STATUS.scheduled:
      return (
        <Button
          className={cn("w-full", className)}
          size={size}
          type="button"
          onClick={() => onNextColumn(REFERRAL_COLUMN.closed, referral)}
        >
          Move to closed
        </Button>
      );
    case REFERRAL_COLUMN_TO_STATUS.closed:
      return (
        <Button
          className={cn("w-full", className)}
          size={size}
          type="button"
          onClick={onPayout}
        >
          Pay advocate
        </Button>
      );
    default:
      return null;
  }
};
